window.MIN_SDF_VALUE = 0.0051;
const MIN_VAL = 0.06;

export default superclass => class extends superclass  {
    onMouseDown(coords) {
        let [x,y] = coords;

        for (let index=0; index < this.lastSDFs.length; index++) {
            let corner = this.corners[index];
            let position = this.positions[index];
            let sdfObject = this.lastSDFs[index];
            let dimensions = this.dimensions[index];
            if (sdfObject && sdfObject.copyId) {
                let indexToAdd = -1;
                let i=0;
                for (let d of this.lastSDFs) {
                    if (d.id === sdfObject.copyId) {
                        indexToAdd = i;
                        break;
                    }
                    i++;
                }
                if (indexToAdd > -1) {
                    let toAdd =  this.positions[indexToAdd];
                    position[0] += toAdd[0];
                    position[1] += toAdd[1];
                    corner = this.corners[indexToAdd];
                    dimensions = this.dimensions[indexToAdd];
                }
            }
            if (dimensions[0] > 0.7) {
                continue;
            }
            let sdf = this.mouseSDF(coords, index, position, dimensions, corner);
            if (sdf < 0) {
                this.mouseDown = index;
                this.sendMessage("Index Clicked", index);
                this.onMouseMove(coords);
                return;
            }
        }
        this.mouseDown = undefined;
        this.sendMessage("Index Clicked", -1);
    }

    screenToGLCoords(x,y) {
        let coord = [x,y];
        let _resolution = this.size || [400, 400];
        let p = [(2*coord[0] - _resolution[0])/_resolution[1],
                 -(2*coord[1] - _resolution[1])/_resolution[1]];
        return p;
    }
    
    mouseSDF(coord, index, position, dimensions, corner) {
        let _resolution = this.size || [400, 400];
        let _off = position || this.positions[index];
        let _b = dimensions || this.dimensions[index];
        let _r = corner || this.corners[index];
        let p = [(2*coord[0] - _resolution[0])/_resolution[1],
                 -(2*coord[1] - _resolution[1])/_resolution[1]];
        p = [p[0] - _off[0], p[1] - _off[1]];
        let q = [Math.abs(p[0])-_b[0]+_r,
                 Math.abs(p[1])-_b[1]+_r];

        return Math.min(Math.max(q[0], q[1]), 0) +
            Math.sqrt(
                Math.pow(Math.max(0, q[0]), 2) +
                    Math.pow(Math.max(0, q[1]), 2)) -
            _r;
    }

    onMouseUp(coords) {
        this.mouseDown = undefined;
    }

    // sends the slider sdfs out the inlet
    onSliderValues(values) {
        if (!this.storedSDFs) {
            return;
        }
        let sdfs = [];
        for (let i=0; i < values.length; i++) {
            let val = values[i];
            let dim = this.dimensions[i];
            let corner = 0;//this.corners[i]*.1;
            if (!dim) {
                continue;
            }
            let min = -Math.min(dim[0] + corner, dim[1] + corner);
            let sdf = min - val*min;
            sdfs.push(Math.max(min + window.MIN_SDF_VALUE, sdf));
        }
        this.sendMessage("On Slider SDF Change", sdfs);
    }

    onMouseMove(coord) {
        if (this.mouseDown !== undefined) {
            let sdf = this.mouseSDF(coord, this.mouseDown);
            let dim = this.dimensions[this.mouseDown];


            let glMouseCoords = this.screenToGLCoords(coord[0], coord[1]);
            let position = this.positions[this.mouseDown];
            let dimension = this.dimensions[this.mouseDown];

            let _corner = this.corners[this.mouseDown];
            if (dimension[0] > dimension[1]) {
                _corner *= .5;
            }
            let maxY = position[1] + dimension[1]/2 + _corner;
            let minY = position[1] - dimension[1]/2 - _corner;

            let sliderVal = (glMouseCoords[1] - minY)/(maxY - minY);
            sliderVal = Math.max(0, Math.min(1, sliderVal));

            let corner = 0; //this.corners[this.mouseDown]*0.1;
            let min = -Math.min(dim[0] + corner, dim[1] + corner);
            sdf = min - sliderVal*min;
            let val = sliderVal;

            /*
            let val = (min-sdf)/min;
            if (val < MIN_VAL) {
                val = 0;
                sdf = min;
            }
            */
            sdf  = (Math.max(min + window.MIN_SDF_VALUE, sdf));
            this.sendMessage("On Slider Change", [this.mouseDown, Math.min(1, val)]);
            this.sendMessage("On Slider SDF Change", [this.mouseDown, Math.min(0, sdf)]);
        }
    }
}
